namespace SorAraBul.PropertyManagement {
    export interface PropertiesForm {
        PropertyType: Serenity.EnumEditor;
        PropertyName: Serenity.StringEditor;
        CityId: Serenity.ServiceLookupEditor;
        IlceId: Serenity.ServiceLookupEditor;
        QuarterId: Serenity.ServiceLookupEditor;
        Address: Serenity.StringEditor;
        Restrictions: Serenity.LookupEditor;
        RequestedRentAmount: Serenity.DecimalEditor;
        RequestedRentCurrencyId: Serenity.LookupEditor;
    }

    export class PropertiesForm extends Serenity.PrefixedContext {
        static formKey = 'PropertyManagement.Properties';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PropertiesForm.init)  {
                PropertiesForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(PropertiesForm, [
                    'PropertyType', w0,
                    'PropertyName', w1,
                    'CityId', w2,
                    'IlceId', w2,
                    'QuarterId', w2,
                    'Address', w1,
                    'Restrictions', w3,
                    'RequestedRentAmount', w4,
                    'RequestedRentCurrencyId', w3
                ]);
            }
        }
    }
}
